import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
// Third party packages
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { forkJoin } from "rxjs";
import { ExportContractsDialogComponent } from "src/app/modules/properties/components/export-contracts-dialog/export-contracts-dialog.component";
import { DocumentArchiveDocsService } from "src/app/modules/properties/document-archive-docs.service";
import { documentArchiveContractItems, documentArchiveExportLoadErrorKey, } from "src/app/modules/properties/document-archive-export.utils";
import { DocumentArchivesService } from "src/app/modules/properties/document-archives.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { isArchiveObjectId } from "src/app/modules/search-docs/document-archive-general-search.utils";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
/**
 * «Esporta contratti» of the dossier on the 3.0.0 archive (FE-M8).
 *
 * The legacy dialog with its data source swapped: it EXTENDS `ExportContractsDialogComponent` and only
 * replaces how the contracts are read, so the Word file is written by the very `onExportFile` of the
 * legacy. The legacy dialog stays as it is for the legacy dossier until the switch.
 *
 * What changes is where the contracts come from:
 *  - `GET /document-archive-docs/tree` instead of `document-archives/:id/contracts`, with the rules of
 *    @see documentArchiveContractItems;
 *  - no `document-archives/settings` and no section computed from the retired `key`: the QR code of a
 *    contract is `/qrcode/d/{_id of the row}` (NEW-A3);
 *  - no longer limited to the properties with a mapping: the tree answers for every archive;
 *  - a failure says so, instead of the legacy "no contract to export".
 *
 * @since 3.0.0
 */
var DocumentArchiveExportContractsDialogComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DocumentArchiveExportContractsDialogComponent, _super);
    /**
     * Class constructor: the dependencies of the legacy dialog, and the service of the new archive
     */
    function DocumentArchiveExportContractsDialogComponent(dialogRef, data, configService, cookieService, translateService, propertiesService, helperService, documentArchivesService, settingsService, documentArchiveDocsService) {
        var _this = _super.call(this, dialogRef, data, configService, cookieService, translateService, propertiesService, helperService, documentArchivesService, settingsService) || this;
        _this.documentArchiveDocsService = documentArchiveDocsService;
        /** Translation key of the message shown when the contracts cannot be read, `""` when they could */
        _this.loadErrorKey = "";
        _this.cookies = cookieService;
        _this.properties = propertiesService;
        return _this;
    }
    /**
     * Read the property, for the title of the file, and the tree, together. Replaces the legacy
     * `ngOnInit` entirely: none of its calls is made.
     *
     * @since 3.0.0
     */
    DocumentArchiveExportContractsDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.lang = this.cookies.get("lang") || this.configService.defaultLang;
        var propertyId = this.data ? this.data.propertyId : undefined;
        if (!isArchiveObjectId(propertyId)) {
            this.dialogIsLoading = false;
            this.loadErrorKey = documentArchiveExportLoadErrorKey(null);
            return;
        }
        this.loadSubscription = forkJoin([
            this.properties.get(propertyId),
            this.documentArchiveDocsService.getTreeByProperty(propertyId),
        ]).subscribe(function (results) {
            _this.dialogIsLoading = false;
            var propertyRes = results[0];
            // ApiService emits a network failure of the legacy route as a VALUE
            if (propertyRes instanceof Error) {
                _this.loadErrorKey = documentArchiveExportLoadErrorKey(propertyRes);
                return;
            }
            var property = propertyRes && propertyRes.status && propertyRes.data ? propertyRes.data : null;
            var tree = results[1] && results[1].data ? results[1].data : null;
            if (!property || !tree) {
                _this.loadErrorKey = documentArchiveExportLoadErrorKey(null);
                return;
            }
            _this.property.setData(property);
            _this.propertyData = property;
            _this.propertyName = typeof property.name === "string" ? property.name : "";
            _this.documentArchive = documentArchiveContractItems(tree.area, _this.lang, _this.configService.frontEndHost);
        }, function (err) {
            _this.dialogIsLoading = false;
            _this.loadErrorKey = documentArchiveExportLoadErrorKey(err);
        });
    };
    /**
     * Destroy component
     *
     * @since 3.0.0
     */
    DocumentArchiveExportContractsDialogComponent.prototype.ngOnDestroy = function () {
        if (this.loadSubscription) {
            this.loadSubscription.unsubscribe();
        }
    };
    return DocumentArchiveExportContractsDialogComponent;
}(ExportContractsDialogComponent));
export { DocumentArchiveExportContractsDialogComponent };
/**
 * Open «Esporta contratti» of the 3.0.0 archive for a property, at the size and with the closing rule
 * of the legacy dialog: how the legacy pages that keep the export open it once the switch is live.
 *
 * @since 3.0.0
 *
 * @param dialog     The MatDialog of the page
 * @param propertyId The property
 */
export function openDocumentArchiveExportContractsDialog(dialog, propertyId) {
    var data = { propertyId: propertyId };
    return dialog.open(DocumentArchiveExportContractsDialogComponent, {
        minWidth: "50%",
        maxHeight: "98vh",
        data: data,
        disableClose: true,
    });
}
